import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "We love the bugzilla and she loves us",
  "description": "",
  "published": "2008-07-04T00:00:00.000Z",
  "redirect_from": ["/blog/we-love-the-bugzilla-and-she-loves-us/swizec/98"],
  "categories": "review",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago I instituted a new organisational paradigm for a project at work - `}<a parentName="p" {...{
        "href": "http://bugzilla.org"
      }}>{`bugzilla`}</a>{`. This move was done because I was getting slowly fed up with everyone coming straight to me to report what's not working well, often something I was either already working on or something that was far away from what I was currenlty doing.`}</p>
    <p>{`Naturally a lot of the stuff got forgotten along the road before I could get around to them, I also had no idea how important something was and how much it broke things. This is where bugzilla comes in. It keeps all bug reports in a nice format, organised by priority `}<em parentName="p">{`and`}</em>{` I get notified of any new bugs or changes to them via e-mail.`}</p>
    <p>{`What I love most is the sequental nature of bug displaying. I can just go to the first bug, resolve it and it shows me the next bug I should work on based on priority and some other things I can't quite fathom. It's awesome because it gives me a clear "This is what you should do next, do it!" so I don't have to bother with organising myself and just focuse on the code.`}</p>
    <p>{`What I don't like about bugzilla, however, is that it's so very obviously made by engineers, for engineers. Worse still, made by bugzilla users for bugzilla users. As a new kid in town it took me quite a while to even figure out how to set things up and teaching my boss to bugreport? HA! I'm lucky he even agreed to using it ... and we're trying to put the application in a public alpha testing next week where anyone should report bugs they find.`}</p>
    <p>{`Luckily though I'm getting more and more used to bugzilla and was so able to put a link on the front page that lists all bugs - I think - and set up a default user with all the login fields already filled in for anyone not wishing to make a special account.`}</p>
    <p>{`No matter the difficulties, bugzilla will be used with all large-ish projects I work on henceforth.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      